import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { DocumentCountsModel, DocumentModel } from '@libs/services/models';
import { FileModel } from '@libs/shared/models';
import { ConnectorService, FileSaverService } from '@libs/shared/services';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentRepositoryService {
  private readonly connector: ConnectorService = inject(ConnectorService);
  private readonly fileSaver: FileSaverService = inject(FileSaverService);

  public getDocuments(): Observable<DocumentModel[]> {
    return this.connector.connect<DocumentModel[]>('service', 'documents');
  }

  public getDocumentCounts(): Observable<DocumentCountsModel> {
    return this.connector.connect<DocumentCountsModel>('service', 'documentCounts');
  }

  // The file name is only known from the content disposition of the response
  public getDocumentFile(fileIdentifier: string): Observable<FileModel> {
    return this.connector.connect<HttpResponse<Blob>>(
      'service',
      'documentFile',
      {
        pathParams: {
          fileIdentifier,
        },
        responseType: 'blob',
        observe: 'response',
      },
    ).pipe(map((response: HttpResponse<Blob>) => this.fileSaver.mapHttpResponseBlobToFileModel(response)));
  }
}
